import React from "react";
import { csv, json } from "d3-fetch";

class SurveyData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      loading: true,
    };
  }

  async fetchData() {
    const { category, locale, statementsOnly, years } = this.props;
    const categorySegment = locale === "uk" ? `/${category}` : "";

    const data = await Promise.all(
      years.map(async (year) => {
        let statementsURL = `/assets/data/${locale}${categorySegment}/statements-${year}.json`;
        let responsesURL = `/assets/data/${locale}${categorySegment}/responses-${year}.csv`;

        let statementsData = await json(statementsURL);

        if (statementsOnly) {
          return {
            year,
            statements: statementsData.statements,
          };
        } else {
          let responses = await csv(responsesURL);

          return {
            year,
            statements: statementsData.statements,
            responses,
          };
        }
      })
    );

    const formattedData = data.reduce((obj, item) => {
      obj[item.year] = item;
      return obj;
    }, {});

    this.setState({
      category: category,
      data: formattedData,
      loading: false,
    });
  }

  render() {
    if (this.state.loading || this.props.category !== this.state.category) {
      this.fetchData();
    }

    const { children } = this.props;
    const { data, loading } = this.state;

    return <React.Fragment>{children(data, loading)}</React.Fragment>;
  }
}

export default SurveyData;
